import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { CategoryAllowedOsUpdate } from '@rocksoft/shared';
import { ConcreteCategory, LocationsRouterStoreSelectors } from '../router';
import * as fromLocationAllowedOsUpdates from './location-allowed-os-updates.reducer';
import { LocationAllowedOsUpdateFeatureKey } from './location-allowed-os-updates.reducer';
import { LocationAllowedOsUpdateState } from './location-allowed-os-updates.state';

export const selectLocationAllowedOsUpdateState = createFeatureSelector<LocationAllowedOsUpdateState>(
  LocationAllowedOsUpdateFeatureKey
);

export const selectLocationAllowedOsUpdates = createSelector(
  selectLocationAllowedOsUpdateState,
  fromLocationAllowedOsUpdates.selectLocationAllowedOsUpdates
);

export const selectLocationAllowedOsUpdatesIds = createSelector(
  selectLocationAllowedOsUpdateState,
  fromLocationAllowedOsUpdates.selectLocationAllowedOsUpdateIds
);

export const selectLocationAllowedOsUpdatesEntities = createSelector(
  selectLocationAllowedOsUpdateState,
  fromLocationAllowedOsUpdates.selectLocationAllowedOsUpdateEntities
);

export const selectLocationAllowedOsUpdatesForLocation = createSelector(
  selectLocationAllowedOsUpdates,
  LocationsRouterStoreSelectors.selectCategory('Location'),
  (updates: CategoryAllowedOsUpdate[], category: ConcreteCategory<'Location'> | undefined) =>
    category ? updates.filter((u) => u.categoryId === category.categoryId) : []
);
